import axios, { AxiosStatic } from 'axios'

export const fetch: AxiosStatic = axios
